/**
 * Shared base for hand-authored line icons — Register A in docs/brand/iconography.md §2.
 *
 * 24×24, single-stroke, `stroke="currentColor"` so the active/idle theme ink applies in BOTH themes
 * (Cozy Pastel + Command Center) and dark mode for free. Decorative by default — the visible label
 * carries meaning. AI generation is a poor fit for this register (it can't inherit `currentColor`); use
 * svgmaker only to ideate a shape, then redraw it by hand as a `LineIcon` (see ./LineIcon.tsx).
 *
 * This module holds ONLY the const + type (no component) so it never trips
 * `react-refresh/only-export-components`.
 */
export const lineIconBase = {
  width: 24,
  height: 24,
  viewBox: '0 0 24 24',
  fill: 'none',
  stroke: 'currentColor',
  strokeWidth: 1.8,
  strokeLinecap: 'round' as const,
  strokeLinejoin: 'round' as const,
  'aria-hidden': true,
};

export type LineIconProps = {
  /** Pixel size; sets width + height (the viewBox stays 24×24). Defaults to 24. */
  size?: number;
  className?: string;
  /**
   * Accessible name. When provided, the icon becomes meaningful (role="img", not aria-hidden) — pass an
   * already-translated string (i18n), never a raw key. Omit for decorative icons next to a text label.
   */
  title?: string;
};
